import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const title = css`
  padding-block-start: ${spacing(2.4375)}; // 19.5px
`
export const selector = css`
  min-block-size: ${spacing(7)}; // 56px
`
